import React from 'react';
import { Link } from 'react-router-dom';
import { Music, Instagram, ExternalLink } from 'lucide-react';
import MusicPlayer from './MusicPlayer';
import './ArtistCard.css';

// Reusable Artist Card - References central artist data
const ArtistCard = ({ artist, showMusic = false, compact = false }) => {
  if (!artist) return null;

  if (compact) {
    return (
      <Link to={`/artists/${artist.id}`} className="artist-card artist-card-compact">
        <div className="artist-card-image">
          <img src={artist.image} alt={artist.name} />
        </div>
        <div className="artist-card-info">
          <h4 className="artist-card-name">{artist.name}</h4>
          <p className="artist-card-genre">{artist.genre.join(', ')}</p>
        </div>
      </Link>
    );
  }

  return (
    <div className="artist-card">
      <Link to={`/artists/${artist.id}`} className="artist-card-image-link">
        <div className="artist-card-image">
          <img src={artist.image} alt={artist.name} />
          <div className="artist-card-overlay">
            <Music className="artist-card-icon" size={48} />
          </div>
        </div>
      </Link>

      <div className="artist-card-content">
        <Link to={`/artists/${artist.id}`}>
          <h3 className="artist-card-name">{artist.name}</h3>
        </Link>
        
        <div className="artist-card-genres">
          {artist.genre.map((genre, index) => (
            <span key={index} className="artist-card-genre-tag">
              {genre}
            </span>
          ))}
        </div>

        <p className="artist-card-bio">{artist.bio}</p>

        {artist.socialLinks && (
          <div className="artist-card-social">
            {artist.socialLinks.instagram && (
              <a 
                href={artist.socialLinks.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="artist-card-social-link"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            )}
            {artist.socialLinks.soundcloud && (
              <a 
                href={artist.socialLinks.soundcloud} 
                target="_blank" 
                rel="noopener noreferrer"
                className="artist-card-social-link"
                aria-label="SoundCloud"
              >
                <Music size={20} />
              </a>
            )}
            {artist.socialLinks.spotify && (
              <a 
                href={artist.socialLinks.spotify} 
                target="_blank" 
                rel="noopener noreferrer"
                className="artist-card-social-link"
                aria-label="Spotify"
              >
                <ExternalLink size={20} />
              </a>
            )}
          </div>
        )}

        {showMusic && artist.music && artist.music.length > 0 && (
          <div className="artist-card-music">
            {artist.music.map((track, index) => (
              <MusicPlayer 
                key={index}
                track={track}
                artistName={artist.name}
                compact={true}
              />
            ))}
          </div>
        )}

        <Link to={`/artists/${artist.id}`} className="artist-card-link">
          View Profile
        </Link>
      </div>
    </div>
  );
};

export default ArtistCard;


